import { toast } from 'sonner';

import { useApiMutation, useApiQuery } from '@/modules/common';

import { CreateMaskBody, MaskUploadUrlData } from '../types';

export function useCreateMask() {
  const {
    data: uploadUrlData,
    isFetching,
    refetch: refetchUploadUrl,
  } = useApiQuery<MaskUploadUrlData>('/masks/upload-url', {
    queryKey: ['maskUploadUrl'],
    initialData: null,
  });

  const createStyleMutation = useApiMutation<CreateMaskBody>(
    '/masks',
    {
      method: 'POST',
    },
    {
      onError: () => {
        toast.error('Uh oh! Something went wrong.');
      },
    }
  );

  return {
    isFetching,
    uploadUrlData,
    refetchUploadUrl,
    createStyleMutation,
  } as const;
}
